import React, { useState } from "react";
import Popup from "../popup/Popup";
import { POPUP_FORM_CONTENT_CLASS, ACTION_POPUP_CONTENT_INNER_CLASS } from "../popup/popupLayoutSpec";
import { AccountPopupField, AccountPopupSaveFooter } from "../BusinessDashboard/accountPopupFields";

const LocationPopup = ({ isOpen, onClose, setFieldValue, values }) => {
  const [location, setLocation] = useState(values?.primaryLocation || "");

  const step = {
    title: "Primary location",
    field: "primaryLocation",
    placeholder: "Richmond",
    inputType: "text",
  };

  const handleSave = () => {
    setFieldValue("primaryLocation", location);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <Popup
      setTrigger={() => {}}
      ShowCrossButton={true}
      cross={true}
      onClose={onClose}
      businessDashboard={true}
      hideLogoInHeader={true}
    >
      <div
        className="overflow-auto relative flex items-center justify-center"
        style={{ minHeight: "calc(100vh - 120px)" }}
      >
        <div className={POPUP_FORM_CONTENT_CLASS}>
          <div className={ACTION_POPUP_CONTENT_INNER_CLASS}>
            <form onSubmit={(e) => e.preventDefault()}>
              <AccountPopupField
                step={step}
                fieldKey="primaryLocation"
                value={location}
                onChange={setLocation}
                form={{}}
              />
              <AccountPopupSaveFooter onClick={handleSave} />
            </form>
          </div>
        </div>
      </div>
    </Popup>
  );
};

export default LocationPopup;
